import React from 'react';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="pt-20 pb-16 md:pt-32 md:pb-24 bg-brand-dark border-b border-brand-gray/30" data-id="element-96">
      <div className="container mx-auto px-4 md:px-6 max-w-5xl text-center" data-id="element-97">
        <h1 className="font-display font-bold text-4xl md:text-6xl lg:text-7xl leading-tight mb-6 uppercase tracking-tight" data-id="element-98">
          Protocolo 22:{' '}
          <span className="text-brand-blue block mt-2" data-id="element-99">
            El Sistema de Reentrenamiento Nervioso
          </span>{' '}
          para el Hombre que se Niega a Seguir Fallando
        </h1>

        <p className="text-lg md:text-2xl text-gray-300 max-w-3xl mx-auto mb-12 font-medium leading-relaxed" data-id="element-100">
          Domina tu cronómetro y recupera el control total en 22 días o menos,
          sin usar fármacos, sprays entumecedores ni trucos psicológicos
          baratos.
        </p>

        <div className="mb-12 relative max-w-3xl mx-auto" data-id="element-101">
          <div className="absolute inset-0 bg-brand-blue/20 blur-3xl rounded-full" data-id="element-102"></div>
          <img src="https://cdn.magicpatterns.com/uploads/fdUBYihwa9Bd217uqajg8X/heylloyd-image-1776793629058.png" alt="Protocolo 22 en múltiples dispositivos" className="relative z-10 w-full h-auto object-contain drop-shadow-2xl" data-id="element-103" />
        </div>

        <CTAButton subtext="Descarga inmediata. Formato PDF compatible con móvil, tablet y PC." data-id="element-104" />
      </div>
    </section>;
}